export default defineNuxtPlugin(async () => {
  const { glowLevel, initGlow } = useGlowSettings();
  await initGlow();

  // Elementos interativos que recebem o efeito interno
  const INTERACTIVE =
    'button, a[href], [role="button"], [role="menuitem"], [role="option"], [role="tab"], [tabindex="0"]';

  let lastEl: HTMLElement | null = null;
  let rafId: number | null = null;
  let pendingX = 0;
  let pendingY = 0;
  let pendingEl: HTMLElement | null = null;

  function applyGlowFrame() {
    rafId = null;
    if (lastEl && lastEl !== pendingEl) {
      lastEl.style.removeProperty("--glow-x");
      lastEl.style.removeProperty("--glow-y");
    }
    if (pendingEl) {
      const rect = pendingEl.getBoundingClientRect();
      pendingEl.style.setProperty("--glow-x", `${((pendingX - rect.left) / rect.width) * 100}%`);
      pendingEl.style.setProperty("--glow-y", `${((pendingY - rect.top) / rect.height) * 100}%`);
    }
    lastEl = pendingEl;
  }

  document.addEventListener(
    "pointermove",
    (e: PointerEvent) => {
      if (glowLevel.value === "off" || e.pointerType === "touch") return;
      pendingX = e.clientX;
      pendingY = e.clientY;
      pendingEl = (e.target as HTMLElement).closest<HTMLElement>(INTERACTIVE);
      // Processa no máximo uma vez por frame de animação
      if (!rafId) rafId = requestAnimationFrame(applyGlowFrame);
    },
    { passive: true },
  );

  // Limpa quando o mouse sai completamente do elemento
  document.addEventListener(
    "pointerleave",
    (e: PointerEvent) => {
      if (!(e.target instanceof Element)) return;
      const el = (e.target as HTMLElement).closest<HTMLElement>(INTERACTIVE);
      if (el) {
        el.style.removeProperty("--glow-x");
        el.style.removeProperty("--glow-y");
      }
    },
    { passive: true, capture: true },
  );
});
